export default __webpack_public_path__ + "static/media/tuphu.515d6521.png";